import turkishLang from 'element-ui/lib/locale/lang/tr-TR'
const messages = {
  ...turkishLang,
  "banner1": "Solplanet markası, daha önce SMA China olarak",
  "banner2": "bilinen AISWEI'e aittir",
  "banner3": "Herkes için Güneş",
  "english": "İngilizce",
  "polish": "Polonyaca",
  "spanish": "İspanyolca",
  "turkish": "Türkçe",
  "germany": "Almanca",
  "french": "Fransızca",
  "italian": "İtalyanca",
  "systemData1": "sistem",
  "installationLocation1": "kurulum",
  "customerData1": "müşteri",
  "claimData": "hak talebi",
  "shippingAddress1": "gönderim",
  "customerData": "Müşteri / Müşteri Verisi",
  "customerType": "Soru türü",
  "selectCustomer": "Lütfen soru türünü seçin",
  "--None--": "--Hiçbiri--",
  "Installer": "Yükleyici",
  "End-customer": "Son müşteriler",
  "Distributor": "Distribütör",
  "EPC": "EPC",
  "Other": "Diğer",
  "companyName": "Şirket Adı",
  "typeCompanyName": "Lütfen şirket adını girin",
  "contacts": "İrtibat Adı",
  "typeContacts": "Lütfen kişi adını girin",
  "contactInformation": "Telefon Numarası",
  "typeContactInformation": "Lütfen telefon numarasını girin",
  "shippingAddress": "Gönderim adresi (lütfen bir değişim halinde bu gönderim adresi olarak kabul edileceğini unutmayın.)",
  "country": "Ülke/Bölge",
  "typeCountry": "Lütfen ülke/bölge adini girin",
  "province": "Devlet",
  "typeProvince": "Lütfen Devlet adını girin",
  "city": "Şehir",
  "typeCity": "Lütfen sehir adını girin",
  "area": "Sokak",
  "typeArea": "Lütfen Sokak adını girin",
  "contacts01": "Cep telefonu",
  "typeContacts01": "Lütfen cep telefonu numarasını girin",
  "postCode": "Posta Kodu",
  "typePostCode": "Lütfen posta kodunu girin",
  "email": "E-Posta",
  "typeEmail": "Lütfen E-posta adresini girin",
  "errorEmail": "Lütfen geçerli bir e-posta adresi girin.",
  "installationLocation": "Kurulum yeri (teslimat adresini kullanın",
  "purchaseDate": "Satın Alma Tarihi",
  "typePurchaseDate": "Lütfen girin",
  "installDate": "Yükleme Tarihi",
  "typeInstallDate": "Lütfen girin",
  "faultyDeviceType": "Arızalı cihazı tipi",
  "selectFaultyDeviceType": "Lütfen girin",
  "faultDate": "Arıza Tarihi",
  "typeFaultDate": "Lütfen girin",
  "deviceSerialNumber": "Cihaz Seri Numarası",
  "typeDeviceSerialNumber": "Lütfen girin",
  "faultySymptom": "Arıza belirtisi",
  "selectFaultySymptom": "Lütfen girin",
  "errorDescription": "Ayrıntılı hata açıklaması",
  "typeErrorDescription": "Lütfen girin",
  "purchaseFileId": "Satın alma belgesi (ek)",
  "purchaseDesc": "Satın alma kanıtı, müşterinin adını, kurulum adresini, invertör modelini ve ödendiğine dair belgeyi içermelidir",
  "breakFileId": "Hata Sertifikası (ek)",
  "breakDesc": "Lütfen kusur detayının bir fotoğrafını, hata mesajını ve ürün seri numarası etiketini gönderin",
  "upload": "Karşıya Yükle",
  "systemData": "Sistem verileri (isteğe bağlı)",
  "systemData01": "Bu, bu sahanın ilk iddiası mı",
  "Yes": "Evet",
  "No": "Hayır",
  "Unknown": "Bilinmiyor",
  "systemData02": "Aynı sahadaki diğer invertörlerin çalışma durumu",
  "systemData03": "Daha önceki iddianın nedeni",
  "enterSystemData03": "Lütfen girin",
  "systemData04": "Aynı sahadaki diğer invertörlerin arıza detayları",
  "enterSystemData04": "Lütfen girin",
  "systemData05": "Invertör kurulumundaki çevre koşulları",
  "systemData0501": "Kapalı ortam",
  "systemData0502": "Açık ortam (bir binanın gölgeli bir yerinde ya da bir çadırın altında)",
  "systemData0503": "Açık ortam (invertör direkt güneş ışığına maruz kalmış)",
  "systemData0504": "Su üstünde",
  "systemData0505": "Diğer",
  "systemData06": "Güneş paneli kurulumu sırasındaki çevre koşulları",
  "systemData0601": "Yerde",
  "systemData0602": "Çatıda",
  "systemData0603": "Su yüzeyinde",
  "systemData0604": "Diğer",
  "systemData07": "Güneş paneli marka ve modeli",
  "typeSystemData07": "Lütfen girin",
  "systemData08": "PV modeli",
  "systemData0801": "Bağımsız",
  "systemData0802": "Paralel",
  "pleaseSelect": "Lütfen seçin",
  "add": "Ekle",
  "delete": "Silmek",
  "pv10": "string solar panel(pieces)",
  "pv101": "PV1 string güneş paneli (adet)",
  "pv102": "PV2 string güneş paneli (adet)",
  "pv103": "PV3 string güneş paneli (adet)",
  "pv104": "PV4 string güneş paneli (adet)",
  "circuit01": "açık devre gerilimi (V)",
  "alternatingVoltage": "Alternatif Gerilim",
  "l1l2": "AC gerilim L1 - L2 (V)",
  "l1n": "AC gerilim L1 - N (V)",
  "l2l3": "AC gerilim L2 - L3(V)",
  "l2n": "AC gerilim L2 - N(V)",
  "l1l3": "AC gerilim L1 - L3 (V)",
  "l3n": "AC gerilim L3 - N(V)",
  "l1pe": "AC gerilim L1 - PE (V)",
  "l3pe": "AC gerilim L3 - PE(V)",
  "l2pe": "AC gerilim L2 - PE(V)",
  "npe": "AC gerilim N - PE (V)",
  "complaintFileId": "Karşıya Yükle",
  "activeTip": "Lütfen dikkat: kurulum hakkında ne kadar ayrıntılı bilgi sağlayabilirseniz, sorunu o kadar hızlı tespit edebiliriz.",
  "submitBtn": "Gönder",
  "pleaseType": "Lütfen girin",
  "submitSuccess": "Başarı gönder",
  "submitDesc": "Bazı gerekli alanlar doldurulmamıştır, lütfen onaydan sonra yeniden havale edin. Teşekkürler!",
  "typeUpload": "Lütfen yükleyin",
  "resetUpload": "yeniden yükleme",
  "selectErrorMessage": "Lütfen seçin",
  "errorMessage": "Diğerleri",
  "MPPT": "MPPT",
  "chinese": "Chinese",
  "dutch": "Dutch",
  "hungary": "Hungary",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Solplanet şart ve koşullarını kabul ediyorum",
  "iagree": "Solplanet şart ve koşullarını kabul ediyorum",
  "language": "Dil",
  "ptbr": "Portekizce (Brezilya)",
  "zhtw": "Geleneksel çince",
  "documentTitle": "Garanti │Solplanet",
  "validateNumber": "Lütfen bir tamsayı girin"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/turkish.js